let MATERIAL_POS_API_URL = ``;
let MATERIAL_Caty_API_URL = ``;
let MATERIAL_API_URL = ``;
let MATERIAL_REPLICA_API_URL = ``;

if (window.location.hostname === "a-dev.tbbt.com.tw"){
  MATERIAL_POS_API_URL = `https://a-dev.tbbt.com.tw/reference-bg/materialPos`
  MATERIAL_Caty_API_URL = `https://a-dev.tbbt.com.tw/reference-bg/materialCaty`
  MATERIAL_API_URL = `https://a-dev.tbbt.com.tw/reference-bg/materials`
  MATERIAL_REPLICA_API_URL = `https://a-dev.tbbt.com.tw/reference-bg/materialsReplica`

} else if (window.location.hostname === "qa-textbook.hle.com.tw" || window.location.hostname === "qa-reference.hle.com.tw"){
  MATERIAL_POS_API_URL = `https://qa-rbook.hle.com.tw/reference-bg/materialPos`
  MATERIAL_Caty_API_URL = `https://qa-rbook.hle.com.tw/reference-bg/materialCaty`
  MATERIAL_API_URL = `https://qa-rbook.hle.com.tw/reference-bg/materials`
  MATERIAL_REPLICA_API_URL = `https://qa-rbook.hle.com.tw/reference-bg/materialsReplica`

}else if (window.location.hostname === "textbook.hle.com.tw" || window.location.hostname === "reference.hle.com.tw"){
  MATERIAL_POS_API_URL = `https://rbook.hle.com.tw/reference-bg/materialPos`
  MATERIAL_Caty_API_URL = `https://rbook.hle.com.tw/reference-bg/materialCaty`
  MATERIAL_API_URL = `https://rbook.hle.com.tw/reference-bg/materials`
  MATERIAL_REPLICA_API_URL = `https://rbook.hle.com.tw/reference-bg/materialsReplica`

} else {
  MATERIAL_POS_API_URL = `https://qa-rbook.hle.com.tw/reference-bg/materialPos`
  MATERIAL_Caty_API_URL = `https://qa-rbook.hle.com.tw/reference-bg/materialCaty`
  MATERIAL_API_URL = `https://qa-rbook.hle.com.tw/reference-bg/materials`
  MATERIAL_REPLICA_API_URL = `https://qa-rbook.hle.com.tw/reference-bg/materialsReplica`
}

class MaterialService {

  retrieveDistinctMainCategoryByYearEduSubject(year, edu, subject) {
    return  axios.get(`${MATERIAL_Caty_API_URL}/${year}/${edu}/${subject}/mains`);
  }

  retrieveDistinctSubCategoryByYearEduSubjectMain(year, edu, subject, main) {
    return  axios.get(`${MATERIAL_Caty_API_URL}/${year}/${edu}/${subject}/${main}/subs`);
  }

  retrieveDistinctYear() {
    return  axios.get(`${MATERIAL_Caty_API_URL}/years`);
  }

   retrieveAllShowMaterialPositions(year, edu, subject, main, sub){
    return  axios.get(`${MATERIAL_POS_API_URL}/show/${year}/${edu}/${subject}/${main}/${sub}`);

  }

  retrieveMaterial(materialId){
    return axios.get(`${MATERIAL_API_URL}/${materialId}`);
  }

  retrieveMaterialCategory(year, edu){
    return axios.get(`${MATERIAL_Caty_API_URL}/${year}/${edu}/materialCaty`)
      .catch(() => {
        // 清空 session 並且回到 index.html
        // sessionStorage.clear()
        // window.location.href = "./index.html"
      })
  }
}
